// extracted by mini-css-extract-plugin
export default {"zoomControls":"V--z","zoomControlButton":"W--z","zoomBanner":"X--z","bannerButton":"Y--z","imageButton":"Z--z","zoom":"_--z","zoomContent":"a_-z"};